import { useService } from 'react-api-service-layer';
import { MessagingService } from '../services/messaging-service';
import { apiServiceContext } from '../../api-service-provider'
import { AxiosApiService } from '../../../services';

export const useMessagingService = () => {
    const apiService = apiServiceContext.useController();
    //  Use the designated api service otherwise create one
    return useService<MessagingService>(MessagingService, apiService || new AxiosApiService());
};
